<app-hero></app-hero>
<app-features></app-features>
<app-how></app-how>
<app-pricing></app-pricing>
<app-why></app-why>
<app-cta></app-cta>
